import React from 'react';

import { TChatAction, TChatState } from '../types/context';

const ChatReducer = (state: TChatState, action: TChatAction): TChatState => {
  switch (action.type) {
    case 'appendMessage': {
      return { ...state, messages: [...state.messages, action.message] };
    }
    case 'askFailed': {
      return {
        ...state,
        conversationId: action.resetConversation ? null : state.conversationId,
        isLoading: false,
      };
    }
    case 'askStarted': {
      return { ...state, isLoading: true };
    }
    case 'askSucceeded': {
      return {
        ...state,
        conversationId: action.conversationId,
        isLoading: false,
      };
    }
    case 'close': {
      return { ...state, isOpen: false };
    }
    case 'open': {
      return { ...state, isOpen: true };
    }
    case 'patchMessage': {
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.id
            ? { ...message, ...action.changes }
            : message,
        ),
      };
    }
    default: {
      throw new Error('Action non autorisée');
    }
  }
};

export default (defaultState: TChatState) =>
  React.useReducer(ChatReducer, defaultState);
